import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/truerix_gold.jpg'


const _withScopeId = n => (_pushScopeId("data-v-076ee0ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"20px","width":"100%","background-color":"rgba(243, 243, 243, 0.55)","padding":"20px 20px 20px","box-shadow":"0 4px 8px rgba(0, 0, 0, 0.2)"} }
const _hoisted_2 = { style: {"width":"100%","text-align":"center","padding-top":"10px","font-family":"'Arial', sans-serif"} }
const _hoisted_3 = { href: "/" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "logo"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  style: {"font-weight":"bolder","text-align":"center","color":"red","margin-top":"10px","font-size":"30px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "员工登录", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","font-style":"italic"} }, "仅供Truerix内部授权用户使用", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "Staff Login", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","font-style":"italic"} }, " For authorized Truerix internal users only ", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("中文")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "员工登录", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","font-style":"italic"} }, "选择进入的模块", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "Staff Login", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","font-style":"italic"} }, " Select the module to enter ", -1))
const _hoisted_28 = {
  key: 0,
  class: "myclass"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "wxlogin3" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-login-other" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"center","padding-top":"10px","font-family":"'Arial', sans-serif"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#8a8a8a","font-weight":"500"} }, " TRUEIX INTERNAL ACCESS ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_lock_outlined = _resolveComponent("lock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_card_grid = _resolveComponent("a-card-grid")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.customActiveKey == 'tab2' ? 'my_menu_main' : 'my_main', "main"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _hoisted_4,
          (!_ctx.is_logo)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "TEST"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_a_form, {
        id: "formLogin",
        layout: "vertical",
        class: "user-layout-login",
        autocomplete: "off"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            "active-key": _ctx.customActiveKey,
            "tab-bar-style": { textAlign: 'center', borderBottom: 'unset' },
            onChange: _ctx.handleTabClick
          }, {
            default: _withCtx(() => [
              (!_ctx.showWx && _ctx.my_all_menu_list.length == 0)
                ? (_openBlock(), _createBlock(_component_a_tab_pane, { key: "tab1" }, {
                    tab: _withCtx(() => [
                      (_ctx.modelRef.currentLang == 'zh-CN')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_6,
                            _hoisted_7,
                            _hoisted_8,
                            _hoisted_9,
                            _hoisted_10
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.modelRef.currentLang == 'en-US')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_11,
                            _hoisted_12,
                            _hoisted_13,
                            _hoisted_14,
                            _hoisted_15
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      (_ctx.isLoginError)
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            type: "error",
                            "show-icon": "",
                            style: {"margin-bottom":"24px"},
                            message: _ctx.t('用户名或密码错误')
                          }, null, 8, ["message"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.username)), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            size: "large",
                            autocomplete: "off",
                            value: _ctx.modelRef.username,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.username) = $event)),
                            placeholder: _ctx.t('请输入用户名'),
                            style: {"width":"100%"}
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_user_outlined, { class: "prefixIcon" })
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.password)), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_password, {
                            autocomplete: "off",
                            value: _ctx.modelRef.password,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.password) = $event)),
                            size: "large",
                            placeholder: _ctx.t('请输入密码')
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_lock_outlined, { class: "prefixIcon" })
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_a_form_item, _mergeProps(_ctx.validateInfos.currentLang, { style: {"text-align":"center"} }), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio_group, {
                            value: _ctx.modelRef.currentLang,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.currentLang) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio, { value: 'zh-CN' }, {
                                default: _withCtx(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_radio, { value: 'en-US' }, {
                                default: _withCtx(() => [
                                  _hoisted_17
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_a_button, {
                        size: "large",
                        type: "primary",
                        "html-type": "submit",
                        class: "login-button",
                        loading: _ctx.loginBtn,
                        onClick: _ctx.handleLoginSubmit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('确定')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.my_all_menu_list.length > 0)
                ? (_openBlock(), _createBlock(_component_a_tab_pane, { key: "tab2" }, {
                    tab: _withCtx(() => [
                      (_ctx.modelRef.currentLang == 'zh-CN')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_18,
                            _hoisted_19,
                            _hoisted_20,
                            _hoisted_21,
                            _hoisted_22
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.modelRef.currentLang == 'en-US')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_23,
                            _hoisted_24,
                            _hoisted_25,
                            _hoisted_26,
                            _hoisted_27
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      (_ctx.my_all_menu_list.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_a_collapse, {
                              activeKey: _ctx.activeKey,
                              "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeKey) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.my_all_menu_list, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                    key: (item.org?.id).toString(),
                                    header: item.org.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_card, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.project_list, (obj) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                              key: obj.id
                                            }, [
                                              (obj.inner_url)
                                                ? (_openBlock(), _createBlock(_component_a_card_grid, {
                                                    key: 0,
                                                    class: "grid",
                                                    style: {"width":"25%","text-align":"center","padding":"12px"},
                                                    onClick: ($event: any) => (
                      _ctx.handleGoMenu({
                        org_id: item.org.id,
                        inner_url: obj.inner_url,
                        nexturl: '',
                        link_url: obj.link_url,
                        url_type: obj.url_type,
                      })
                    )
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("img", {
                                                        src: obj.icon_url,
                                                        height: "50",
                                                        width: "50"
                                                      }, null, 8, _hoisted_29),
                                                      _createElementVNode("div", null, _toDisplayString(obj.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["header"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["activeKey"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showWx)
                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                    key: "tab3",
                    tab: "体验账号登录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        bordered: false,
                        style: {"text-align":"center"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["active-key", "onChange"]),
          _hoisted_31
        ]),
        _: 1
      })
    ]),
    _hoisted_32
  ], 2))
}